import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';

import BaseCleanerTask from './Layouts/CleaningTasks';
import CleanerForm from './form';

import { TASK_MODEL } from 'services/entity/task';
import { cloneTaskInitialValues } from '../../../Task/Form/options';
import { transformTaskFormValues } from 'utils/DataTransform/Task/taskForm';
import MessageForm from 'containers/Pages/Messages/Layouts/MessageForm';
import { actions as dataGridActions } from './Modules/dataGridTable';
import { CleaningColumns } from './columns';
import { serviceTypes } from 'utils/constants/serviceTypes';
import CleanerTaskDetails from './cleanerTaskDetails';
import { getUserRoles } from 'reducers/users';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';
import { PAGE_URLS } from 'utils/constants';
import { detailOpenState } from 'reducers/ui';

const Task = ({ updateTask, isTemplate = false, editable = true }) => {
  const defaultFilterValues = {
    taskCategory: [serviceTypes.cleaning],
  };
  const detailOpen = useSelector(state => detailOpenState(state));
  const onChange = ({ id, value, task, selected }) => {
    const parentTaskType = task?.tasks.find(f => f.id === id);
    if (!selected.isDummyTask) {
      const data = {
        tasks: [
          {
            ...parentTaskType,
            id,
            [TASK_MODEL.assignee.id]: value.id,
            [TASK_MODEL.assigneeFullName.id]: value.name,
            [TASK_MODEL.assigneeImageUrl.id]: value.photoUrl,
          },
        ],
      };
      updateTask({ data });
      return;
    }

    // eslint-disable-next-line no-unused-vars
    const { id: newID, ...newFormInitial } = cloneTaskInitialValues({
      taskToCloneId: id,
      taskToCloneDetails: task,
      allowSubTask: true,
      defaultValues: {
        isTemplate: selected.isTemplate,
        taskType: parentTaskType?.taskType,
      },
    });

    const data = transformTaskFormValues({
      values: {
        ...newFormInitial,
        isTemplate: false,
        schedule: selected.schedule,
        schedulePatterns: undefined,
        assigneeId: {
          id: value.id,
          name: value.name,
        },
        multiSchedule: false,
        allowSubTask: true,
      },
    });
    updateTask({ data });
  };

  const [msg, setMsg] = useState(false);

  const setMessage = () => {
    setMsg(true);
  };

  const resetMsg = () => {
    setMsg(false);
  };

  const CleanerDetailsComponent = useCallback(({ id, selected, ...props }) => {
    return (
      <CleanerTaskDetails
        id={id}
        selected={selected}
        {...props}
        onChange={onChange}
        setMessage={setMessage}
        resetMsg={resetMsg}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const userRoles = useSelector(state => getUserRoles(state));
  return (
    <BaseCleanerTask
      editable={editable}
      downloadable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      FormComponent={msg ? MessageForm : CleanerForm}
      cols={CleaningColumns}
      defaultFilterValues={defaultFilterValues}
      isTemplate={isTemplate}
      DetailComponent={CleanerDetailsComponent}
      persistentStateName={PAGE_URLS.CLEANING_TASKS.name}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.CLEANING_TASKS.link]}
    />
  );
};
Task.propTypes = {
  clearCleanerTaskDetails: PropTypes.func,
  updateTask: PropTypes.func,
  isTemplate: PropTypes.bool,
  editable: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  updateTask: ({ data }) => dispatch(dataGridActions.updateRowEntry({ data })),
});

export default connect(null, mapDispatchToProps)(Task);
